import React from "react";

import {Typography} from "@mui/material";
import {SxProps} from "@mui/material/styles";
import {typografNode} from "../../utils/typograf";

type H4Props = {
    children: React.ReactNode;
    className?: string;
    sx?: SxProps;
};

function H4({children, className, sx}: H4Props) {
    return (
        <Typography component="h4" variant="h4" sx={[{
            alignItems: 'center',
            display: 'inline-flex',
            fontWeight: '900',
            fontFamily: 'Nexa Heavy, Nexa, Roboto, sans-serif',
            letterSpacing: 0,
            '@media screen and (min-width: 1400px)': {
                fontSize: '32px',
                lineHeight: 1.35,
            },
            '@media (min-width: 1200px)': {
                display: 'block',
                fontSize: '32px',
                lineHeight: 1.28,
            },
            '@media screen and (min-width: 992px) and (max-width: 1199px)': {
                fontSize: '28px',
                lineHeight: 1.36,
            },
            '@media screen and (min-width: 768px) and (max-width: 1199px)': {
                display: 'block',
                position: 'relative',
                top: '4px',
                fontSize: '28px',
                lineHeight: 1.28,
                overflowWrap: 'normal',
            },
            '@media screen and (max-width: 767px)': {
                fontSize: '24px',
                lineHeight: 1.42,
                display: 'block',
                maxWidth: '100%',
                minWidth: 0,
                overflowWrap: 'break-word',
                wordBreak: 'normal',
                whiteSpace: 'normal',
                width: '100%',
                textWrap: 'balance',
            },
            '@media screen and (min-width: 576px) and (max-width: 767px)': {
                fontFamily: 'Nexa Heavy, Nexa, Roboto, sans-serif',
                fontSize: '24px',
                fontWeight: 900,
                lineHeight: 1.28,
                textWrap: 'pretty',
                overflowWrap: 'normal',
                position: 'relative',
                top: '4px',
            },
            '@media screen and (max-width: 575px)': {
                lineHeight: 1.28,
                position: 'relative',
                top: '4px',
                textWrap: 'pretty',
                overflowWrap: 'normal',
            },
        }, ...(Array.isArray(sx) ? sx : [sx ?? false])]} className={className}>
            {typografNode(children)}
        </Typography>
    );
}

export default H4
